import { useMemo } from "react";
import { useGetFaUsersQuery } from "#graphql/supergraphHooks";

export interface FaUserOption {
  id: string;
  displayName: string;
  email: string | null;
}

interface UseFaUsersResult {
  users: FaUserOption[];
  loading: boolean;
  error: Error | null;
}

export function useFaUsers(arenaId: number | undefined): UseFaUsersResult {
  const { data, loading, error } = useGetFaUsersQuery({
    variables: { arenaId: arenaId ?? 0 },
    skip: !arenaId,
  });

  const users = useMemo<FaUserOption[]>(
    () =>
      (data?.faUsersForArena ?? []).map((u) => ({
        id: String(u.id),
        displayName: u.displayName,
        email: u.email ?? null,
      })),
    [data],
  );

  return { users, loading, error: error ?? null };
}
